import { compose, propOr, sortWith } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';
import { sortAlphabeticallyBy } from 'utils/sort';

const getRoot = propOr(EMPTY_VALUES.OBJECT, 'marketPlaceAgencies');

export const getMarketPlaceAgencies = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'agencies'));
export const getNotAssignedManagers = createSelector(
	getRoot,
	compose(
		sortWith([sortAlphabeticallyBy('surname'), sortAlphabeticallyBy('firstname')]),
		propOr(EMPTY_VALUES.ARRAY, 'notAssignedManagers'),
	),
);
export const getRegions = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'regions'));
export const getSegments = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'segments'));
export const getAgencyManagersAndSubordinates = createSelector(
	getRoot,
	propOr(EMPTY_VALUES.OBJECT, 'agencyManagersAndSubordinates'),
);
export const getOriginalValues = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'original'));

export const getAgencyManagersAndSubordinatesById = createSelector(
	(state, id) => id,
	getAgencyManagersAndSubordinates,
	(id, agencyManagersAndSubordinates) => {
		const managersAndSubordinates = propOr(EMPTY_VALUES.ARRAY, id)(agencyManagersAndSubordinates);

		return sortWith([sortAlphabeticallyBy('surname'), sortAlphabeticallyBy('firstname')])(managersAndSubordinates);
	},
);

export const getPristineStates = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'pristineStates'));
export const getManagerLogin = createSelector(getRoot, propOr(EMPTY_VALUES.STRING, 'managerLogin'));
